import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

@Component({
	selector: 'app-filter-chip',
	templateUrl: './filter-chip.component.html',
	styleUrls: ['./filter-chip.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None
})
export class FilterChipComponent {
	@Input() label = '';
	@Input() removeAriaLabel = '';
	@Input() removable = true;

	@Output() readonly remove = new EventEmitter<void>();

	onRemove(): void {
		if (!this.removable) {
			return;
		}

		this.remove.emit();
	}
}
